import { OverlayRef } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const IMAGE_OVERLAY_DATA = new InjectionToken('imageOverlayData');

export interface ImageOverlayData {
  readonly src: string;
  readonly overlay: OverlayRef;
}
